<script>
import CountriesApi from "@/services/countries-api";
import UsersApi from "@/services/users-api";
import CustomerApi from "@/services/customers-api";


export default {
      components: {},
  data() {
    return {
        usersFilter:null,
        usersList: [],
        customersList:[],
        customersFilter:null,
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        customersListFields: 
            [
                { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                { key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"city", label: "",   thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none"},
                { key:"phone", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"extId", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none"},
                { key:"paymentConditions", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none"},
                { key:"status", label: "",thClass:"text-center", tdClass:"text-center"},
                { key:"users", label: "",thClass:"text-center", tdClass:"text-center"},
                { key:"trader", label: "",thClass:"text-center", tdClass:"text-center"},
                { key:"actions", label:""}
            ],
        type:null,
        isCustomersTableBusy:false,
        showDetailsModal:false,
        showConditionsModal:false,
        citiesList:[],
        countriesList:[],
        selectedCountry:null,
        selectedCity:null,
        if_form_error:false,
        showForm:false,
        selectedUser:{id:'',name:'',userName:'',password:'',supplierId:null,status:1,},
        showUsersModal:false,
        isNew:false,
        selectedUserList:[],
        isPasswordChange:false,
        newPassword:null,
        selected:{country:"",city:""},    
        passwordHidden:true,
        showTraderModal:false,
        tradersList:[],
        selectedTrader:null,
        selectedPDF:null,
        gotTradersList:false,
      }
      
    },

    
  mounted() {
    this.findCustomers()
    this.getCountries()
  },

  methods: {

    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
       CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
          result => {
            this.citiesList = result
        })
     },
    
    findCustomers(){
          this.isCustomersTableBusy = true;
              CustomerApi.getAllCustomers(this.customersFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedCountry ? this.selectedCountry.id : null,this.selectedCity ? this.selectedCity.id : null).then(
                  response => {
                      if(response) {
                        this.customersList= response.list
                        this.pagemodelMain.totalRows = response.total;
                        this.pagemodelMain.currentPage = response.page;
                        this.pagemodelMain.perPage = response.pageSize;
                        this.pagemodelMain.pageSize = response.pageSize;
                      }   
                  }
              )
              .finally(() => {
             this.isCustomersTableBusy = false;
      });
    },

    getUserInfo(id){
        UsersApi.getUserInfo(id).then(
            result => {
                this.selectedUserList=result
                this.showUsersModal=true
            })
    },


    addNew(){
      this.cancelUserEdit();
      this.showForm =true;
      this.isNew=true
      this.isPasswordChange=false
    } ,

    cancelUserEdit(){
      this.isNew=false
      this.selectedUser.id=null
      this.selectedUser.name=''
      this.selectedUser.userName=''
      this.selectedUser.password=''
    },

    hideForm(){
      this.showForm =false;
      this.isNew=false
    },

    editUser(user){
        this.showForm =true;
        this.isPasswordChange=false
        this.cancelUserEdit();
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
        this.selectedUser.status=user.status
    },

    saveUser(){
      this.selectedUser.customerId= this.selected ? this.selected.id : null
      UsersApi.saveUser(this.selectedUser).then(
        (result)=> {
            if(result){
                this.getUserInfo(this.selectedUser.customerId)          
                this.cancelUserEdit()
                this.hideForm()
            }

        }
      )
    },

    showHidePassword(){
        this.passwordHidden=!this.passwordHidden
    },
    changePassword(user){
        this.isPasswordChange = true
        this.hideForm()
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
    },
    cancelPasswordChangeEdit(){
        this.isPasswordChange= false
        this.cancelUserEdit()
        this.newPassword=null
    },

    updatePassword(){
        this.selectedUser.supplierId= this.selected ? this.selected.id : null
        UsersApi.adminUpdatePassword(this.selectedUser.id,this.newPassword).then(
        ()=> {
            this.getUserInfo(this.selectedUser.supplierId)          
            this.cancelPasswordChangeEdit()
        }
      )
    },

    deliveryModeToLabel(deliveryMode){
      switch(deliveryMode) {
        case 0: return 'supplier';
        case 1: return 'carrier';
        default: return 'supplier';
      }
    },

    getTraders(){
        UsersApi.getAllTraders().then(
            (result)=>{
                this.tradersList=result
                this.gotTradersList=true
            }
        )
    },


    saveTraderToCustomer(){
      if(this.selectedTrader==null){
        this.selectedTrader={name:''}
      }
      this.selectedTrader.customerId= this.selected ? this.selected.id : null
      UsersApi.saveTraderToCustomer(this.selectedTrader).then(
        (result)=> {
            if(result){
                this.showTraderModal=false       
            }

        }
      )
    },


    getTrader(item){
        if(!this.gotTradersList){
            this.getTraders()
        }
        this.selected=item;
        UsersApi.getTrader(this.selected ? this.selected.id : null).then(
            (result)=>{
                if(result && result.id){
                    this.selectedTrader=result
                }else{
                    this.selectedTrader=null
                }
                
                this.showTraderModal=true

            }
        )
    },

    onPDFUpload(id){
      if(!this.selectedPDF) {
          return;
      }
      const fd = new FormData();
      fd.append('file', this.selectedPDF, this.selectedPDF.name)
      CustomerApi.saveFilePDF(fd,id).then(
          () =>{
                this.findCustomers();

                }
      ).finally(
          this.selectedPDF=null
      )
    },

    downloadPaymentConditions(fileName){
      CustomerApi.downloadPaymentConditions(fileName)
    }

},

    watch: {
        selectedCountry: function(){
          if(this.selectedCountry != null){
            this.getCities()
          }else{
              this.citiesList=[]
          }
            this.findCustomers()
        },

        selectedCity: function(){
            this.findCustomers()

        },
    }



};
</script>
<template>
    <div class="row   ">    
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-10">
                <h2 class="card-title font-size-25" style="font-size:25px;">
                    <span class="d-none d-sm-inline   ">
                        {{$t('subscription.text')}} 
                    </span>
                </h2>
                </div>
            </div>

            <div class="row p-0 m-0 pb-2 mt-0 ">
                <div class ="col-xl-4 col-lg-4 col-md-12 col-cm-12 col-xs-12 ">
                    <b-form-group :label="$t('subscription.nameFilter.label')" >
                        <b-input-group  >
                            <b-form-input :placeholder="$t('subscription.nameFilter.placeholder')"   v-model="customersFilter"   @keyup.native.enter="findCustomers() "
                                ></b-form-input>                              
                            <template v-slot:append>
                                <b-button variant="warning" @click="findCustomers()" >
                                <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                                </b-button>
                            </template>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class ="col-xl-2 col-lg-2 "/>
                <div class ="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <b-form-group :label="$t('lists.countries.filter')" label-for="">
                        <v-select class="style-vselect  font-size-16"  :options="countriesList" :placeholder="$t('lists.countries.label')"  label="name" v-model="selectedCountry">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <b-form-group :label="$t('lists.cities.filter')"  label-for="">
                        <v-select class="style-vselect   font-size-16"  :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
            </div>

            <div class="table-responsive"> 
                <b-table 
                :busy="isCustomersTableBusy"
                :striped="true"
                :small="false"
                :hover="true"
                :items="customersList"
                :fields="customersListFields"
                :perPage="pagemodelMain.perPage"
                class="table  "
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>
                <template v-slot:head(companyName)>
                    {{ $t("subscription.table.name") }} 
                </template>
                <template v-slot:head(country)>
                    {{ $t("subscription.table.country") }} 
                </template>
                <template v-slot:head(city)>
                    {{ $t("subscription.table.city") }} 
                </template>
                <template v-slot:head(extId)>
                    {{ $t("subscription.table.code") }} 
                </template>
                <template v-slot:head(phone)>
                    {{ $t("subscription.table.phone") }} 
                </template>
                <template v-slot:head(paymentConditions)>
                    {{ $t("subscription.table.paymentConditions") }} 
                </template>
                <template v-slot:head(status)>
                    {{ $t("subscription.table.status") }} 
                </template>
                <template v-slot:head(users)>
                    {{ $t("subscription.table.users") }} 
                </template>
                 <template v-slot:head(trader)>
                    {{ $t("subscription.table.trader") }} 
                </template>
                <template v-slot:cell(status)="{value}">
                    <i :class="value===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
                </template>
                <template v-slot:cell(country)="{value}">
                    {{value.name}}
                </template>
                <template v-slot:cell(city)="{value}">
                    {{value.name}}
                </template>
                <template v-slot:cell(users)="{item}">
                    <i class="fas fa-users-cog text-warning font-weight-bold font-size-14" @click="selected=item;hideForm();isPasswordChange=false;getUserInfo(item.id);" style="cursor:pointer" :title="$t('subscription.manageUsers')" ></i>
                </template>
                <template v-slot:cell(actions)="{item}">
                    <i class="fas fa-info-circle text-info font-weight-bold font-size-16" style="cursor:pointer" :title="$t('subscription.showDetails')" @click="selected=item;showDetailsModal=true" ></i>
                </template>
                <template v-slot:cell(trader)="{item}">
                    <i class="fas fa-user-tie text-primary font-weight-bold font-size-16" style="cursor:pointer" :title="$t('subscription.showTrader')" @click="getTrader(item)" ></i>
                </template>
                <template v-slot:cell(paymentConditions)="{item}">

                    <label   :for="String(item.id)+'ref'" class="css-class">
                        <i v-b-tooltip.hover :title="$t('subscription.paymentConditions.upload')" class="fas fa-upload text-info font-size-16 mr-3" style="cursor:pointer"></i>
                        <b-form-file v-model="selectedPDF"  :id="String(item.id)+'ref'"   @input="onPDFUpload(item.id)" style="display:none"></b-form-file>
                    </label>
                    <a v-bind:style="[item.paymentConditionsPDF ? {'visibility':'visible'} :{'visibility':'hidden'}]"  @click.prevent="downloadPaymentConditions(item.paymentConditionsPDF)" 
                    class="action-icon font-size-12 font-weight-bold text-info mr-3" :title="$t('subscription.paymentConditions.download')"  style="cursor:pointer">
                    {{$t('subscription.paymentConditions.label')+item.name }}
              </a>
                </template>
                </b-table>
                <span v-if="!isCustomersTableBusy & !customersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("subscription.table.empty")}}</span>
            </div>
            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="findCustomers()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodelMain.currentPage" :disabled="isCustomersTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findCustomers()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->
            

          </div>
        </div>
      </div>


    <b-modal v-if="selected"
    v-model="showDetailsModal"
        :title="$t('subscription.detailsModal.title')"
        centered 
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        hide-footer
        size="xl">
        <div class="row mb-4 mt-2">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary"><i class="fas fa-user-tie font-size-16 mr-2"/>{{$t('subscription.detailsModal.name')}} </span>
              <br/><span class="font-size-14">{{selected.name == null ? "-" : selected.name}}</span>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary"><i class="fas fa-phone font-size-16 mr-2"/>{{$t('subscription.detailsModal.phone')}}</span>
              <br/><span class="font-size-14">{{selected.phone == null ? "-" : selected.phone}}</span>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class="font-weight-bold font-size-16 text-primary "><i class="fas fa-coins font-size-16 mr-2"/>{{$t('subscription.detailsModal.inProgress')}}</span>  
                <br/><span class="font-size-14">{{selected.inProgress== null ? "-" : selected.inProgress}}</span>
            </div>

        </div>

        <div class="row mt-4 mb-4">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary "><i class="fa fa-industry font-size-16 mr-2"/>{{$t('subscription.detailsModal.companyName')}}</span>  
              <br/><span class="font-size-14">{{selected.companyName == null ? "-" :  selected.companyName}}</span>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary"><i class="fas fa-envelope font-size-16 mr-2"/>{{$t('subscription.detailsModal.mail')}}</span>
              <br/><span class="font-size-14">{{selected.mail== null ? "-" :selected.mail }}</span>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class="font-weight-bold font-size-16 text-primary "><i class="fas fa-credit-card font-size-16 mr-2"/>{{$t('subscription.detailsModal.ceiling')}}</span>  
                <br/><span class="font-size-14">{{selected.ceiling == null ? "-" : selected.ceiling}}</span>
            </div>

        </div>

        <div class="row mt-4 mb-2">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary"><i class="fas fa-hashtag font-size-16 mr-2"/>{{$t('subscription.detailsModal.code')}}</span>
              <br/><span class="font-size-14">{{selected.extId == null ? "-" :selected.extId   }}</span>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary"><i class="fas fa-flag font-size-16 mr-2"/>{{$t('subscription.detailsModal.country')}}</span>
              <br/><span class="font-size-14">{{selected.country == null ? "-" : selected.country.name == null ? "-" : selected.country.name }}</span>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class="font-weight-bold font-size-16 text-primary "><i class="fas fa-percent font-size-16 mr-2"/>{{$t('subscription.detailsModal.currency')}}</span>  
                <br/><span class="font-size-14">{{selected.currency == null ? "-" :selected.currency }}</span>
            </div>

 
        </div>

        <div class="row mt-4 mb-2">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary"><i class="fas fa-city font-size-16 mr-2"/>{{$t('subscription.detailsModal.address')}}</span>
              <br/>  
                <ul v-for="address in selected.addresses" :key="address" >
                    <li class="font-size-14">{{address}}</li>
                </ul>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <span class="font-weight-bold font-size-16 text-primary"><i class="fas fa-city font-size-16 mr-2"/>{{$t('subscription.detailsModal.city')}}</span>
              <br/><span class="font-size-14">{{selected.city.name == null ? "-" : selected.city.name == null ? "-" : selected.city.name }}</span>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <span class="font-weight-bold font-size-16 text-primary "><i class="fas fa-question font-size-16 mr-2"/>{{$t('subscription.detailsModal.taxRefNumber')}}</span>  
                <br/><span class="font-size-14">{{selected.taxRefNumber == null ? "-" :selected.taxRefNumber   }}</span>
            </div>

        </div>


    </b-modal>

    <b-modal
            v-if="showUsersModal && selected"
            v-model="showUsersModal"
            :title="$t('subscription.userModal.title') +selected.name "
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            size="lg"
    >
        <b-button
            variant="link"
            class="p-0 m-0 pb-3  text-info font-weight-bold font-size-14 float-right" 
            @click="addNew()"
            >
            <i class="fas fa-edit " ></i>
            <span class="ml-2">{{$t('subscription.userModal.addNew')}} </span>
        </b-button>
        <div v-if="showForm" class="float-left">
            <div  class="form-group  ">
                <b-form-checkbox
                    value="1"
                    unchecked-value="0"
                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                    v-model="selectedUser.status"
                    >   
                    <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-info' : 'text-muted'">{{selectedUser.status == 1 ? $t('subscription.userModal.status.active') : $t('subscription.userModal.status.disabled')}}</span>
                </b-form-checkbox>
            </div>
        </div>



        <div v-if="isPasswordChange" class="row mt-4" style="width:100%">
            <div class="form-group row mb-3">
            <label class="col-md-6 col-form-label" for="pwd">{{$t('subscription.userModal.passwordNew')}} {{selectedUser.name}}</label>
                <div class="col-md-4">
                    <form autocomplete="off">
                        <div class="input-group ">
                            <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="newPassword" >
                            <div class="input-group-append">
                                <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword()" ></i></span>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-md-2" >
                    <b-button variant="secondary" @click="cancelPasswordChangeEdit();" class="mr-2 ml-2" >
                        <i class="fas fa-times font-size-14 align-middle  " ></i>
                    </b-button>
                    <b-button variant="success" @click="updatePassword()" >
                        <i class="fas fa-save font-size-14 align-middle  " ></i>
                    </b-button>
                </div>
            </div>
        </div>
        <div v-if="showForm" class="row mt-4" style="width:100%">
            <div class="form-group col-sm-3 pr-2">
                <label >{{$t('subscription.userModal.form.name')}}</label>
                <input
                type="text"
                class="form-control"
                v-model="selectedUser.name"
                />
            </div>
            <div class="form-group col-sm-3 pr-2">
                <label >{{$t('subscription.userModal.form.userName')}}</label>
                <input
                type="text"
                class="form-control"
                v-model="selectedUser.userName"

                />
            </div>
            <div v-if="isNew" class="form-group col-sm-3 pr-2">
                <label >{{$t('subscription.userModal.form.password')}}</label>
                <form autocomplete="off">
                        <div class="input-group ">
                            <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="selectedUser.password" >
                            <div class="input-group-append">
                                <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword()" ></i></span>
                            </div>
                        </div>
                </form>
            </div>

            <div class="col-sm-2" style="padding-top:26px; padding-bottom:26px;">
            <b-button variant="secondary" @click="cancelUserEdit();hideForm();" class="mr-2" >
                <i class="fas fa-times font-size-14 align-middle  " ></i>
            </b-button>
            <b-button variant="success" @click="saveUser()" >
                <i class="fas fa-save font-size-14 align-middle  " ></i>
            </b-button>
        </div>
        </div>  
        <div class="table-responsive"  >
            <table class="table table-centered " >
            <thead class="thead-light">
                <tr>
                    
                <th class="text-left">{{$t('subscription.userModal.table.status')}}</th>
                <th class="text-left">{{$t('subscription.userModal.table.name')}}</th>
                <th class="text-left">{{$t('subscription.userModal.table.userName')}}</th>
                <th></th>
                <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in selectedUserList" :key="user.id" >
                    <td><i :class="user.status===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i></td>
                    <td>{{user.name}}</td>
                    <td>{{user.userName}}</td>
                    <td>
                        <b-button @click="changePassword(user)"  size="sm" variant="outline-dark"  >
                            <i class="fas fa-key font-size-16 align-middle mr-2"></i>{{$t('subscription.userModal.table.chnagePassword')}}
                        </b-button>
                    </td>
                    <td>
                        <a  :title="$t('subscription.userModal.table.edit')" href="javascript:void(0);"  @click="editUser(user)" class="action-icon text-warning pr-2" >
                            <i class="mdi mdi-pencil font-size-22"  />
                        </a>

                    </td>
                </tr>

            </tbody>
            </table>
            <span v-if="this.selectedUserList && !this.selectedUserList.length " class="d-flex justify-content-center m-4 text-danger" > {{$t('subscription.userModal.table.empty')}} </span>

            </div> 
    </b-modal>

    <b-modal
            v-if="showTraderModal && selected"
            v-model="showTraderModal"
            :title="$t('subscription.traderModal.title') +selected.name "
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            size="lg"
            hide-header-close
            no-close-on-backdrop
            no-close-on-esc
    >
    <b-form-group label="" label-for="">
        <v-select :options="tradersList" :placeholder="$t('subscription.traderModal.tradersList')" label="name" v-model="selectedTrader">
        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
        </v-select>
    </b-form-group>

        <div class="table-responsive" v-if="selectedTrader" >
            <table class="table table-centered " >
            <thead class="thead-light">
                <tr>
                    <th class="text-left">{{$t('subscription.traderModal.table.name')}} </th>
                    <th class="text-left">{{$t('subscription.traderModal.table.jobTitle')}}</th>
                    <th class="text-left">{{$t('subscription.traderModal.table.userName')}}</th>
                    <th class="text-left">{{$t('subscription.traderModal.table.phone')}}</th>
                </tr>
            </thead>
            <tbody>
                    <td>{{selectedTrader.name}}</td>
                    <td>{{selectedTrader.jobTitle == null ? "_":selectedTrader.jobTitle }}</td>
                    <td>{{selectedTrader.userName}}</td>
                    <td>{{selectedTrader.phone == null ? "_":selectedTrader.phone }}</td>
            </tbody>
            </table>

        </div> 
        <span v-if="!this.selectedTrader " class="d-flex justify-content-center m-4 text-danger" >{{$t('subscription.traderModal.table.empty')}} {{this.selected.name}}</span>

            <template v-slot:modal-footer>
                <b-button variant="secondary" @click="showTraderModal = false" size="md">{{$t('buttons.cancel')}}</b-button>
                <b-button  variant="warning" @click="saveTraderToCustomer()" size="md" ><span class="text-primary font-weight-bold">{{$t('buttons.save')}}</span></b-button>
            </template>
    </b-modal>
    
    </div>
</template>